// extracted by mini-css-extract-plugin
module.exports = {"container":"PartnersItem_container__LY7pp","image":"PartnersItem_image__t8jgE"};